import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../common.service';
import { FormBuilder,FormGroup,Validators } from '@angular/forms';
import Swal from 'sweetalert2';
declare var $: any;
@Component({
  selector: 'app-addfarmsmanagement',
  templateUrl: './addfarmsmanagement.component.html',
  styleUrls: ['./addfarmsmanagement.component.css']
})
export class AddfarmsmanagementComponent implements OnInit {
  returnUrl= "/dashboard/farmsmanagement";
  addfarmsFormValue:any;
  getspeciesvalue:any;
  addUrl: any;
  geturl:any;
  registerForm:FormGroup;
  loginresponse:any;
  cby_mby:any;
  submitted = false;
  constructor(private router: Router, private commonService: CommonService,private formBuilder: FormBuilder) { }

  ngOnInit(): void {
    this.loginresponse=JSON.parse(sessionStorage.getItem('userrole'));
    this.cby_mby=this.loginresponse.user_id;
    $('.selectpicker').selectpicker('refresh');
    this.registerForm = this.formBuilder.group({
      farmname: ['', Validators.required],
      farmid: ['', Validators.required],
    farmcontactname: ['', [Validators.required, Validators.pattern(/^[a-zA-Z\s]+$/)]],
    email: ['',Validators.compose([Validators.required,Validators.email,Validators.pattern(/^(\d{10}|\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3}))$/)])],
    mobileNumber: ['', [Validators.required, Validators.pattern("[0-9 ]{10}")]],
    Address: ['', Validators.required]
  });
   
  }
 
  get f() { return this.registerForm.controls; }
  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.registerForm.invalid) {
        return;
    }
    // display form values on success
   this.farmsmanagement()
  }
  async farmsmanagement(){
    this.addfarmsFormValue = {
      "farm_name": $("#farmname").val(),
      "code":$("#farmid").val(),
      "farm_contact_name":$("#farmcontactname").val(),
      "farm_contact_email":$("#farmcontactemail").val(),
      "farm_contact_number":$("#ContactNumber").val(),
      "farm_address":$("#Address").val(),
      "status" : 1,
      "cby":this.cby_mby
  };
  console.log(this.addfarmsFormValue )
  this.addUrl = "/farms";
    (await this.commonService.postApi(this.addUrl,this.addfarmsFormValue)).subscribe(
      data => {
          alert('Data added successfully');
          setTimeout(
            () : void => {
    
              this.router.navigate([this.returnUrl]);
    
            },
            500
          );
      },
      err => {
        Swal.fire("Duplicate values",'Farm Id already Exist');
      });

      //setTimeout(function(){  this.router.navigate([this.returnUrl]); }, 500)
     
    
     
  }
  backnavigate(){
    this.router.navigate([this.returnUrl]);
  }

}
